export const Npi = "npi";
export const PmsId = "pmsid";
export const MemberId = "member id";
export const CalendarId = "calendar id";
export const ServiceId = "service id";
export const SiteId = "site id";
export const SystemId = "system id";
